<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">신고포상제</h1>
      <p class="page-tit">공동 운영 제도</p>
    </div>
    <!-- 공동 운영 제도 -->
    <section class="section-pt">
      <div class="description">
        <h2 class="section-title">공동 운영 제도</h2>
        <p class="description__content">
          - 민간 기업에서 버그바운티를 도입하려 하나 기반 마련이 어려울 때,
          KISA가 수년간 버그바운티를 운영한 경험을 바탕으로 기업이 자체적으로
          버그 바운티를 운영할 수 있도록 단계적으로 지원하는 제도<br />
          - 공동운영사로 참여하는 업체는 취약점 평가회의에 참석하여 적성성을
          논의하고 결정된 포상금을 지급
        </p>
      </div>
      <div class="divider-tit__wrap">
        <h3 class="divider-tit">버그바운티 구축 시 고려사항</h3>
      </div>
      <ul class="card-list">
        <li class="card-list__item">
          <div class="card-list__icon" aria-hidden="true">
            <img
              src="@/assets/img/cooperation/icon_scope.svg"
              alt=""
              class="light-only"
            />
            <img
              src="@/assets/img/cooperation/icon_scope_dark.svg"
              alt=""
              class="dark-only"
            />
          </div>
          <div class="card-list__content">
            <strong class="card-list__title">대상범위(제품) 지정</strong>
            <p class="card-list__desc">
              버그바운티를 허용하는 <br />
              대상범위를 선정합니다.
            </p>
          </div>
        </li>
        <li class="card-list__item">
          <div class="card-list__icon" aria-hidden="true">
            <img
              src="@/assets/img/cooperation/icon_award.svg"
              alt=""
              class="light-only"
            />
            <img
              src="@/assets/img/cooperation/icon_award_dark.svg"
              alt=""
              class="dark-only"
            />
          </div>
          <div class="card-list__content">
            <strong class="card-list__title">예산, 포상기준 마련</strong>
            <p class="card-list__desc">
              취약점 보급도, 공격 유형별 <br />
              포상기준을 마련합니다.
            </p>
          </div>
        </li>
        <li class="card-list__item">
          <div class="card-list__icon" aria-hidden="true">
            <img
              src="@/assets/img/cooperation/icon_system.svg"
              alt=""
              class="light-only"
            />
            <img
              src="@/assets/img/cooperation/icon_system_dark.svg"
              alt=""
              class="dark-only"
            />
          </div>
          <div class="card-list__content">
            <strong class="card-list__title">입수체계 구축</strong>
            <p class="card-list__desc">
              취약점 신고 받을 <br />
              웹페이지를 제작합니다.
            </p>
          </div>
        </li>
        <li class="card-list__item">
          <div class="card-list__icon" aria-hidden="true">
            <img
              src="@/assets/img/cooperation/icon_review.svg"
              alt=""
              class="light-only"
            />
            <img
              src="@/assets/img/cooperation/icon_review_dark.svg"
              alt=""
              class="dark-only"
            />
          </div>
          <div class="card-list__content">
            <strong class="card-list__title">대상범위(제품) 지정</strong>
            <p class="card-list__desc">
              취약점 검증/평가/예산 지급을 <br />
              진행할 역할을 분답합니다.
            </p>
          </div>
        </li>
      </ul>
    </section>
    <!-- 공동 운영 이점 -->
    <section class="section-pt">
      <h2 class="section-title">공동 운영 이점</h2>
      <p class="description__content">
        - 기업 버그바운티 운영을 위한 단계적 지원 활용(평가체계 등)<br />
        ※ KISA에서 취약점 접수, 분석, 검증, 평가를 지원하며 추후 자체적으로
        운영할 수 있도록 단계별로 독립
        <br />
        - 국제표준식별체계 CVE 발급이 필요한 경우, MITRE 연계 서비스 제공<br />
        - 공동운영사로 참여하는 업체는 KISA 취약점 포탈 홈페이지에 정보보호 활동
        강화 기업 홍보<br />
        - 클라우드 기반 보안 취약점 분석 플랫폼 서비스 제공
      </p>
    </section>
    <!-- 공동 운영을 위한 협약 절차 -->
    <section class="section-pt">
      <h2 class="section-title">공동 운영을 위한 협약 절차</h2>
      <ol class="step-list">
        <li class="step-list__item">
          <span class="step-list__badge">STEP 01</span>
          <strong class="step-list__title"
            >KISA 공동운영사 신고포상제 운영 안내 회의</strong
          >
          <div class="step-list__content">
            <p class="step-list__desc">- 신고포상제 현황, 평가체계 소개</p>
            <p class="step-list__desc">
              - 참여 기업 취약점 신고 현황 및 예상 포상금 추이
            </p>
          </div>
        </li>
        <li class="step-list__item">
          <span class="step-list__badge">STEP 02</span>
          <strong class="step-list__title">참여 기업 내부 결정 사항</strong>
          <div class="step-list__content">
            <p class="step-list__desc">- 포상 대상 범위 설정 필요</p>
            <p class="step-list__desc">
              - 포상금 예산 확보(제조사 평균 신고건수, 파급도 고려)
            </p>
          </div>
        </li>
        <li class="step-list__item">
          <span class="step-list__badge">STEP 03</span>
          <strong class="step-list__title"
            >KISA, 참여 기업 신고포상제 공동운영 협약 체결</strong
          >
          <div class="step-list__content">
            <p class="step-list__desc">
              - KISA, 공동운영사 협약 서명(대면보고/서면보고)
            </p>
            <p class="step-list__desc">
              - (가능한경우) 언론보도 홍보, 취약점 포탈 홈페이지에 정보보호 활동
              강화 기업 홍보
            </p>
          </div>
        </li>
        <li class="step-list__item">
          <span class="step-list__badge">STEP 04</span>
          <strong class="step-list__title"
            >공동운영사 분기별 신고포상제 평가위원으로 참여</strong
          >
          <div class="step-list__content">
            <p class="step-list__desc">
              - 3, 6, 9, 12월 둘째 주에 신고포상제 회의 개최
            </p>
            <p class="step-list__desc">
              - (각 분기에 해당 제조사 취약점이 신고된 경우) 평가위원으로 참석
            </p>
            <p class="step-list__desc">
              - KISA 내부 평가 자료 검토 및 평가위원들과 최종 포상금 조정
            </p>
          </div>
        </li>
        <li class="step-list__item">
          <span class="step-list__badge">STEP 05</span>
          <strong class="step-list__title"
            >공동운영사 포상 대상 신고자에게 포상금 수여</strong
          >
          <div class="step-list__content">
            <p class="step-list__desc">
              - 최종평가 회의 후 KISA측에서 신고자 정보, 제조사 취약점 평가결과
              전달
            </p>
            <p class="step-list__desc">- 공동운영사에서 신고자 포상금 지급</p>
          </div>
        </li>
      </ol>
    </section>
    <!-- 공동 운영 절차 -->
    <section class="section-pt">
      <h2 class="section-title">공동 운영 절차</h2>
      <figure aria-hidden="true" class="diagram-area">
        <picture class="light-only">
          <!-- 모바일용 -->
          <source
            srcset="@/assets/img/cooperation/img_process_m.png"
            media="(max-width: 767.9px)"
          />
          <!-- 태블릿용 -->
          <source
            srcset="@/assets/img/cooperation/img_process_tb.png"
            media="(max-width: 1399.9px)"
          />
          <!-- PC용 -->
          <img src="@/assets/img/cooperation/img_process.png" alt="" />
        </picture>
        <picture class="dark-only">
          <!-- 모바일용 -->
          <source
            srcset="@/assets/img/cooperation/img_process_m_dark.png"
            media="(max-width: 767.9px)"
          />
          <!-- 태블릿용 -->
          <source
            srcset="@/assets/img/cooperation/img_process_tb_dark.png"
            media="(max-width: 1399.9px)"
          />
          <!-- PC용 -->
          <img src="@/assets/img/cooperation/img_process_dark.png" alt="" />
        </picture>
      </figure>
      <ol class="sr-only">
        <li>
          <strong>1단계 - 내용/주체</strong>
          <ul>
            <li>1. 입수(KISA)</li>
            <li>2. 취약점 검증 및 분석(KISA)</li>
            <li>3. 취약점 평가(KISA)</li>
            <li>3. 취약점 포상(공동운영사)</li>
          </ul>
        </li>
        <li>
          <strong>2단계 - 내용/주체</strong>
          <ul>
            <li>1. 입수(KISA)</li>
            <li>2. 취약점 검증 및 분석(KISA)</li>
            <li>3. 취약점 평가(공동운영사)</li>
            <li>3. 취약점 포상(공동운영사)</li>
          </ul>
        </li>
        <li>
          <strong>3단계 - 내용/주체</strong>
          <ul>
            <li>1. 입수(KISA)</li>
            <li>3. 취약점 검증 및 분석(공동운영사)</li>
            <li>3. 취약점 평가(공동운영사)</li>
            <li>3. 취약점 포상(공동운영사)</li>
          </ul>
        </li>
        <li>
          <strong>4단계 - 내용/주체</strong>
          <ul>
            <li>3. 입수(공동운영사)</li>
            <li>3. 취약점 검증 및 분석(공동운영사)</li>
            <li>3. 취약점 평가(공동운영사)</li>
            <li>3. 취약점 포상(공동운영사)</li>
          </ul>
        </li>
      </ol>
    </section>
  </div>
</template>
